import { render, staticRenderFns } from "./SaveToOnebox.vue?vue&type=template&id=5bc60a65&"
import script from "./SaveToOnebox.vue?vue&type=script&lang=js&"
export * from "./SaveToOnebox.vue?vue&type=script&lang=js&"
import style0 from "./SaveToOnebox.vue?vue&type=style&index=0&id=5bc60a65&prod&scopted=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports